import { FormattedMessage } from 'react-intl'
import { clsx } from 'clsx'

import { Badge } from 'Components/_theme'

import {
  getReturnCasePortalStatusBadgeColor,
  getReturnCasePortalStatusBadgeVariant,
  getReturnCasePortalStatusTranslationId,
} from 'Portal/src/utilities/getReturnCasePortalStatus/getReturnCasePortalStatus.utils'

import type { ReturnPortalStatusBadgeProps } from './ReturnPortalStatusBadge.types'

export const ReturnPortalStatusBadge = (
  props: ReturnPortalStatusBadgeProps,
) => {
  const { className, portalStatus } = props

  return (
    <Badge
      className={clsx(className)}
      color={getReturnCasePortalStatusBadgeColor(portalStatus)}
      textWrap
      variant={getReturnCasePortalStatusBadgeVariant(portalStatus)}
    >
      <FormattedMessage
        id={getReturnCasePortalStatusTranslationId(portalStatus)}
      />
    </Badge>
  )
}
